/**
 * Zweck: Kennzeichnet den produktiven Angular-Build und aktiviert Produktionsverhalten.
 */
export const environment = {
  production: true,
};
